// トップスライダーの起動 
jQuery(function($) {

	if ( $('#kv_slider').length > 0 ) {
		const TIME_PAUSE = 8000,
			TIME_DURATION = 2000,
			TIME_RETURN_CIRCLE = 800,
			$slider = $('#kv_slider'),
			$circle = $('#slider_nav #circle_anim'),
			path = $circle.attr("r") * 2 * 3.14,
			$indicate = $('#slider_nav'),
			slide_num = $slider.find('.block').length;


		// フェードスライダーの設定
		const options = {
			autoplay: true,
			arrows: false,
			infinite: true,
			autoplaySpeed: TIME_PAUSE,	//　スライダー表示時間
			speed: TIME_DURATION,			// スライド変化時間
			dots: false,
			fade: true,
			pauseOnFocus: false,		// スライダーにフォーカスしたらオートプレイを停止
			pauseOnHover: false,		// スライダーにマウスオーバーでオートプレイを停止
			pauseOnDotsHover: false,	// ドットナビゲーションにフォーカスしたらオートプレイを停止
		}

		// ナビゲーション初期設定
		initNav();
		drawCircle(0, TIME_PAUSE);

		// スライダー
		$slider.slick(options)
			.on("beforeChange", function(event, slick, currentSlide, nextSlide) {	// スライド変化前
				$indicate.find(".current_slide").text(nextSlide + 1);
				drawCircle(1, TIME_RETURN_CIRCLE);
			}).on("afterChange", function(slick, currentSlide) {	// スライド変化後
				drawCircle(0, TIME_PAUSE);
			});

		/**
		 * ナビゲーションの初期設定
		 */
		 function initNav() {
			// ナビゲーション
			// path = $circle.attr("r") * 2 * 3.14;
			$circle.css({
				"stroke-dasharray": path,
				"stroke-dashoffset": path,
			});
			
			// スライダーナビーションの設定
			$indicate.find(".slide_num").text(slide_num);
			$indicate.find(".current_slide").text(1);
			// if (aIdx !== -1) {
			// 	$indicate.find(".current_slide").text(aIdx + 1);
			// } else {
			// 	$indicate.find(".current_slide").text(1);
			// }
		}

		/**
		 * ナビゲーションの円周アニメーション
		 * @param {number} direction => 0 (forwards) or 1 (backwards)
		 * @param {*} duration => 変化時間
		 */
		function drawCircle(direction, duration) {
			if (direction === 0) {
				$circle.css({
					"stroke-dasharray": path,
					"stroke-dashoffset": path,
				});
				$circle.animate({ "stroke-dashoffset": 0 }, duration);
			} else if (direction === 1) {
				$circle.css({
					"stroke-dasharray": path,
					"stroke-dashoffset": 0,
				});
				$circle.animate({ "stroke-dashoffset": path }, duration);
			}
		}


	}
});

jQuery(function($) {
	if ( $('.top_service_slider.swiper-container').length ) {
		var $allSlide = $('.top_service_slider.swiper-container');
		var allSwiper = new Swiper('.top_service_slider.swiper-container', {
			slidesPerView:"auto",
			spaceBetween: 15,
			loop:false,
			scrollbar: {
				el: ".slider_controls .control_bar",
				draggable:true,
			},
			navigation: {
	        	prevEl: ".slider_controls .arrow_prev",
	            nextEl: ".slider_controls .arrow_next",
	        },

	        breakpoints: {
	        	601: {
			      spaceBetween: 20
			    },
	        }
		});
		allSwiper.on('slideChange', function () {
		  if ( allSwiper.isBeginning ) {
			$(".slider_controls .arrow_prev").addClass("swiper-button-disabled");
			}
			if ( allSwiper.isEnd ) {
			$(".slider_controls .arrow_next").addClass("swiper-button-disabled");
			}
		});
	}
})